import Vue from 'vue'
const jwtDecode = require('jwt-decode')

let requestInterceptor
let responseInterceptor

const state = new Vue({
  data() {
    return {
      state: {
        $route: null,
        app: {
          recaptchaLoaded: false,
          recaptchaToken: null,
          apiUrl: process.env.VUE_APP_apiUrl,
          registerWithAppSuccess: false,
          registerWithoutAppSuccess: false,
          token: null,
          savedForm: false,
          appUrl: process.env.VUE_APP_appUrl,
          isVertrieb: false
        },
        user: {
          id: null
        },
        ui: {

        },
        dateCheck: {
          from: new Date("2020-07-03T20:00:00"),
          to: new Date("2020-07-10T19:00:00")
        },
        emptyUserData: {},
        userData: {
          forename: '',
          name: '',
          companyName: '',
          email: '',
          emailConfirm: '',
          salutation: 'Herr',
          street: '',
          streetNumber: '',
          zip: '',
          city: '',
          acceptContact: null,
          createApp: true,
          customApp: {
            contactTel: '',
            contactMobile: '',
            contactEmail: '',
            contactEmailConfirm: '',
            website: '',
            skype: '',
            facebook: '',
            instagram: '',
            description: ''
          }
        }
      }
    }
  },
  computed: {
    compIsLoggedIn() {
      if (this.state.app.token) return true
      return false
    },
    compHasCustomApp() {
      if (!this.state.app.token) return false
      if (this.state.userData.customApp._id) return true
      return false
    },
    compShowAcceptContact() {
      if (this.compIsLoggedIn) {
        if ((this.state.app.savedForm && this.state.userData.acceptContact)) return false
      } else {
        return true
      }
      return true
    },
    compShowByDate() {
      if (new Date() >= this.state.dateCheck.from && new Date() < this.state.dateCheck.to) {
        return false;
      }
      return true;
    }
  },
  methods: {
    trackingView(tname, conversionType='-') {
      let sysEnv = process.env.NODE_ENV == 'production' ? 'prod' : 'dev';
      let pageName = "SBU_"+tname;
      let issueDate = "SBU_LP2020|"+ new Date().toLocaleDateString('de-DE');

      let trackingObj = {
        "event": "PageLoaded",
        "page": {
          "pageInfo": {
            "pageName": pageName, //Pagename , Werte s.u.
            "issueDate": issueDate, //SBU_LP2020| ist fix. Dahinter dynamisches Änderungsdatum des aktuell dargestellten Contents
            "sysEnv": sysEnv // dev oder prod je nachdem auf welcher Umgebung man gerade ist
          },
          "category": {
            "primaryCategory": "SBU_LandingPage", //fixer Wert
            "pageType": "SBU_LandingPage", //fixer Wert
            "pagePurpose": "SBU_BrokerCampaign"//fixer Wert
          },
          "attributes":{
            "viewPort": null, //falls berechenbar der dargestellte Viewport (z.B. mobile, tablet, desktop, etc)
            "brokerModus": "Off", //fixer Wert
            "displayedBrand": "ERGO" //fixer Wert
          }
        },
        "transaction":{
          "attributes":{
            "conversionType": conversionType //nur wenn conversionType unten bei pageName oder clickedElement definiert ist
          }
        }
      }

      // console.log(trackingObj);
      window.appEventData.push(trackingObj);
    },
    trackingClick(elemName) {
      let sysEnv = process.env.NODE_ENV == 'production' ? 'prod' : 'dev';
      let clickedElement = "SBU_"+elemName;
      let issueDate = "SBU_LP2020|"+ new Date().toLocaleDateString('de-DE');
      

      let trackingObj = {
        "event": "GeneralClick",
        "eventdetails": {
          "clickedElement": clickedElement, //Name des geklickten Elements s.u.
          "clickType": "other"
        },
        "page": {
          "pageInfo": {
            "issueDate": issueDate, //SBU_LP2020 ist fix. Dahinter dynamisches Änderungsdatum des aktuell dargestellten Contents
            "sysEnv": sysEnv // dev oder prod je nachdem auf welcher Umgebung man gerade ist
          }
        },
        "product": [{
          "productInfo":{
            "attributes":{
              "tariffOptions2": "Landingpage=SBU_LandingPage|MakN=MaxMustermann" //"Landingpage=SBU_LandingPage|" ist fixer Wert. Maklername in "MakN" speichern (Wert aus URL übernehmen)
            }
          }
        }]
      }

      // console.log(trackingObj);
      window.appEventData.push(trackingObj);

    },
    /*
    Gets called when error occurs, if for example the token is expired or invalid, or if the login link is clicked when it has already been used.
    */
    async requestLoginToken() {
      await this.$sleep(500)
      let userId
      let email
      try {
        let decoded = jwtDecode(this.state.app.token)
        userId = decoded.payload.userId
      } catch(err) {
        console.error(err)
      }
      if (!userId) {
        //console.log(this.state.$route)
        email = this.state.$route.query.email
      }
      if (!userId && !email) {
        await this.$fire({
          title: 'Fehler!',
          text: "Es ist ein unerwarteter Fehler aufgetreten. Bitte loggen Sie sich aus und fordern Sie einen neuen Login-Link an. Sollte das Problem weiterhin bestehen, wenden Sie sich bitte an den Support oder warten Sie einige Zeit und versuchen Sie es später erneut.",
          type: "error"
        })
        return
      } 
      try {
        let model = {}
        const token = await this.$recaptcha('login')
        model.recaptchaToken = token
        model.email = email
        model.userId = userId
        let result = await this.$http.post(this.state.app.apiUrl + 'login', model)
      } catch(err) {
        console.log(err)
        await this.$fire({
          title: 'Fehler!',
          text: err.response.data.message,
          type: "error"
        })
        return
      }
      await this.$fire({
        title: 'Kurzer Sicherheitscheck.',
        text: "Um Ihre persönlichen Daten zu schützen, haben wir gerade einen neuen Login-Link an Ihre E-Mail-Adresse verschickt. Schauen Sie nur kurz in Ihr Postfach – und weiter geht‘s!",
        type: "success"
      })
    },
    /*
      decode token from app state
      set user id
      set local storage token
      call function to set http auth token in every request
    */
   async login() {
      console.log("store login")
      let decoded
      try {
        decoded = jwtDecode(this.state.app.token)
        //console.log('decoded webtoken: ', decoded)
      } catch(err) {
        console.error(err)
        await this.$fire({
          title: "Fehler!",
          text: "Fehler beim Login. Eventuell ist ihre Session abgelaufen. Fehlermeldung: " + err,
          type: "error"
        })
        this.logout()
        return
      }
      this.state.user.id = decoded.payload.userId
      decoded.payload.customAppId && (this.state.user.customAppId = decoded.payload.customAppId)
      this.$ls.set('token', this.state.app.token)
      this.$store.setHttpHeaderToken()
      let userData
      try {
        userData = await this.$store.getUserData()
        if (!userData.data) {
          this.$store.logout()
          return
        }
        this.state.userData = Object.assign(this.state.userData, userData.data)
        if (this.state.userData.acceptContact) {
          //console.log("set savedform true")
          this.state.app.savedForm = true
        }
      } catch(err) {
        /*
        await this.$fire({
          title: "Fehler!",
          text: "Fehler beim Abrufen ihrer Nutzerdaten. Fehlermeldung: " + err.response.data.message,
          type: "error"
        })
        */
       //console.log("bin hier 2")
        await this.requestLoginToken()
        this.logout()
        return
      }
    },
    async editApp(model) {
      let result
      //console.log('edit app', model)
      try {
        const token = await this.$recaptcha('edit')
        model.recaptchaToken = token
        result = await this.$http.post(this.state.app.apiUrl + 'broker', model)
      } catch(err) {
        throw (err)
      }
      return result
    },
    //user registers and creates app
    async registerWithApp(model) {
      let result
      try {
        model.recaptchaToken = await this.$recaptcha('register')
        model.finanzvertrieb = this.state.app.isVertrieb
        result = await this.$http.post(this.state.app.apiUrl + 'broker', model)
      } catch(err) {
        throw (err)
      }
      this.$store.trackingView("app_extended_form_sent");
      return result
    },
    //user just wants access downloads - no app created
    async registerWithoutApp(model) {
      let result
      try {
        const token = await this.$recaptcha('register')
        model.recaptchaToken = token
        model.finanzvertrieb = this.state.app.isVertrieb
        result = await this.$http.post(this.state.app.apiUrl + 'broker', model)
      } catch(err) {
        throw (err)
      }
      this.$store.trackingView("downloads_form_sent");
      return result
    },
    //when user is logged in but does not have an app
    createApp() {

    },
    setHttpHeaderToken() {
      requestInterceptor = this.$http.interceptors.request.use((config) => {
        config.headers.Authorization = `Bearer ${this.state.app.token}`
        return config
      }, (error) => {
        return Promise.reject(error)
      })
      responseInterceptor = this.$http.interceptors.response.use((response) => {
        //console.log("response")
        return response
      }, (error) => {
        //console.log(error.response)
        if (error.response && error.response.data.message == 'Session nicht valide.') {
          error.response.data.message =  error.response.data.message + ' Bitte melden Sie sich erneut an, indem Sie einen Login-Link anfordern.'
          this.logout()
        }
        return Promise.reject(error)
      })
    },
    async handleLogout() {
      try {
        await this.logout()
        await this.$fire({
          title: "",
          text: 'Sie haben sich erfolgreich ausgeloggt. Um sich einzuloggen fordern Sie einfach einen neuen Login-Link an!',
          type: "success"
        })
      } catch(err) {
        console.error(err)
      }
    },
    async logout() {
      try {
        let result = await this.$http.post(this.state.app.apiUrl + 'logout', {})
        //console.log(result)
      } catch(err) {
        //console.log(err.response)
        throw (err)
      }
      this.$http.interceptors.request.eject(requestInterceptor)
      this.$http.interceptors.request.eject(responseInterceptor)
      this.state.userData = JSON.parse(JSON.stringify(this.state.emptyUserData))
      /*
      this.$http.interceptors.request.use((config) => {
        config.headers.Authorization = null
        return config
      }, (error) => {
        return Promise.reject(error)
      })
      */
      this.state.app.token = null
      this.$ls.remove('token')
    },
    async getUserData(model) {
      let result
      try {
        result = await this.$http.get(this.state.app.apiUrl + 'broker')
      } catch(err) {
        throw (err)
      }
      return result
    },
  }
})

export const store = state
